import {
  Segment,
} from "@ispm-client/modules/segments/interfaces";
import * as jsonPath from 'jsonpath';


export class FieldMappingTransformation {


  /**
   * This method will transform given fieldMapping model field data
   */
  public transform(segment: Segment,fieldMapping:any,segIdentifier) {
    let returnValue:any={};
    if (fieldMapping.fields) {
      fieldMapping.fields.forEach(field => {
        if (segIdentifier.length > 1) {
          returnValue = this.formArrayField(fieldMapping,segment,segIdentifier);
        } else{
          returnValue = this.formObjectField(fieldMapping,segment,segIdentifier);
        }
      });
    }
    return returnValue;
  }


  /**
   * This method will transform given fieldMapping model field into array
   */
  formArrayField(fieldMapping,segmentData,segmentIdentifier){
    let segmentDataJson = JSON.parse(JSON.stringify(fieldMapping));
    let structure = jsonPath.value(segmentDataJson,"$.fields[?(@.type=='object')].fields");
    let mappingObj = {};
    let finalObj={};
    let innerObj = {};
    const segmentDataArray = segmentData.name.toString().split("-");
    segmentIdentifier.forEach(element => {
      mappingObj[element] = segmentDataArray[segmentIdentifier.indexOf(element)];
    })
    structure.forEach(obj => {
      let jsonStructure = JSON.parse(JSON.stringify(obj));
      let innerField = jsonPath.value(jsonStructure,"$.fields");
      innerField.forEach(obj1 => {
        innerObj[`${obj1.modelField}`] = mappingObj[obj1.segmentField];
      });
      finalObj[`${obj.modelField}`] = innerObj;
      innerObj={};
    });
    return finalObj;
  }


  /**
   * This method will transform prostate location as an array of object
   */
  formObjectField(fieldMapping,segmentData,segmentIdentifier){
    let fields = jsonPath.value(fieldMapping,"$.fields[?(@.type=='object')].fields");
    let finalObj = {};
    segmentIdentifier.forEach(element => {
      fields.forEach(obj => {
        finalObj[`${obj.modelField}`] = segmentData[element];
      })
    })

    return finalObj;
  }


  /**
   * This method is used for getting the base model field name for each segment definition
   */
  getModelFieldName(fieldMapping):string{
    let baseModelField = jsonPath.value(fieldMapping,"$.fields[?(@.type=='array' || @.type=='object')].modelField");
    return baseModelField;
  }

  /**
   * This method is used for getting the code from a structured object via jsonpath
   */
  getCode(segmentInfo,field,segIdentifier,fieldMapping){
    let jsonData =  JSON.parse(JSON.stringify(segmentInfo));
    //let searchString = '$..'+field+'.code';
    /*if(segIdentifier.length > 1){
      searchString = '$..'+field+'.code';
    }*/

    if(segIdentifier.length == 1){
      field = this.getModelFieldName(fieldMapping);
    }
    let searchString = '$..'+field+'.code';
    let result = jsonPath.query(jsonData,searchString);
    return result.toString();

    }
  /**
   * This method is responsible for providing mapping between model field and segment field
   */
  segmentToModelMapper(segAnn):Object{
    let segmentMapper ={};
    let jsonPathExp = jsonPath.value(segAnn,"$..jsonPath");
    let jsonData =  JSON.parse(JSON.stringify(segAnn));
    let modelArray = jsonPath.query(jsonData,jsonPathExp);
    let segmentArray = jsonPath.query(jsonData,"$..fields[?(@.type=='text')].segmentField");
    segmentArray = segmentArray.filter((item,index,inputArr) => {
      return inputArr.indexOf(item) == index;
    })
    //modelArray = modelArray.filter(element => element!= this.getModelFieldName(segAnn.fieldMappings));
    segmentArray.forEach(element => {
      segmentMapper[element] = modelArray[segmentArray.indexOf(element)];
    });
    return segmentMapper;

  }

  getLevelInfo(annData: any):string{
    let jsonData =  JSON.parse(JSON.stringify(annData));
    let level = jsonPath.query(jsonData,"$..level");
    return level;
  }
}

